module.exports = __webpack_public_path__ + "static/soc4-b3d2911edab82dac82dfdb58321b8a44.png";